import React, { useContext, useEffect, useLayoutEffect } from 'react'
import ReactDOM from 'react-dom'

import DataContext from '../../contexts/data.jsx'

import DeliveryStore from './Store.jsx'
import DeliveryStoreInfo from './StoreInfo.jsx'

const DeliveryStores = ({ delivery, setData }) => {
    let defaultStore = null,
    storesShowsIDs = []

    const data = useContext(DataContext),
    handleChangeStore = (store) => {
        const newContextData = Object.assign({}, data)

        newContextData.delivery.store_id = parseInt(store.ID) || null

        setData(newContextData)
    },
    checkRestriction = (store) => {
        if (!defaultStore) {
            defaultStore = store
        }

        storesShowsIDs.push(store.ID)

        return true
    }

    useEffect(() => {
        if (!data.delivery.store_id && defaultStore) {
            handleChangeStore(defaultStore)
        }
    }, [])

    useLayoutEffect(() => {
        if (storesShowsIDs.length > 0) {
            if (data.delivery.store_id > 0) {
                if (storesShowsIDs.indexOf(data.delivery.store_id) === -1) {
                    handleChangeStore(data.data._stores[storesShowsIDs[0]])
                }
            } else if (data.data._stores[storesShowsIDs[0]]) {
                handleChangeStore(data.data._stores[storesShowsIDs[0]])
            }
        }
    })

    if (delivery.PICKUP && delivery.STORES && delivery.STORES.length > 0) {
        return <div className="happy-order__delivery-stores">
            <div className="happy-order__delivery-stores-title">Выберите удобный пункт выдачи заказов:</div>

            <div className="happy-order__delivery-stores-data">
                <div className="happy-order__delivery-stores-list">
                    { delivery.STORES.map(( store ) => {
                        return checkRestriction(store) ? <DeliveryStore
                            key={ `delivery-store-${ store.ID }` }
                            store={ store }
                            data={ data }
                            handleChangeStore={ handleChangeStore }
                        /> : null
                    }) }
                </div>

                { delivery.STORES.map(( store ) => {
                    return (data.delivery.store_id == store.ID) ? <DeliveryStoreInfo
                        key={ `delivery-store-info-${ store.ID }` }
                        store={ store }
                        data={ data }
                    /> : null
                }) }
            </div>
        </div>
    }

    return null
}

export default DeliveryStores